import { createRoutine } from 'redux-saga-routines';

export const fetchDonorSummaryReport = createRoutine(
  'FETCH_INVENTORY_DONOR_SUMMARY_REPORT'
);
